// extracted by mini-css-extract-plugin
export default {"ProjectView":"ProjectView_ProjectView__xlSa9","ProjectViewWithBorder":"ProjectView_ProjectViewWithBorder__t6rtf"};